import React from "react";
import './VestiPage.scss';
import VestiComponent from "../VestiComponent/VestiComponent";
import VestData1 from '../../assets/json/vesti/vest1.json';
import VestData2 from '../../assets/json/vesti/vest2.json';
import VestData3 from '../../assets/json/vesti/vest3.json';
import VestData4 from '../../assets/json/vesti/vest4.json';
import VestData5 from '../../assets/json/vesti/vest5.json';
import VestData6 from '../../assets/json/vesti/vest6.json';

const VestiPage: React.FC = () => {
    
    return (
        <div className="vesti-page-container" id="scrollElement9">
            <h1 className="vesti-title document-main-title">Zanimljivosti</h1>
            <div className="novosti-container">
                {/*OVDE NOVOSTI*/}
                {/* <div className="one-novost-container">
                    <div className="credits-container">
                        <p className="author-p">Aleksandar Butulija</p>
                        <p className="date-p">07.10.2004.</p>
                    </div>
                    <div className="title-container">
                        <h2>Naslov vesti</h2>
                    </div>
                    <div className="novost-row-container">
                        <div className="image-credits-container">

                            <img src={"/images/radionice/ws1s1.jpg"} alt="Slika vesti"/>
                            
                        </div>
                        <div className="content-container">
                            <p className="content-p">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae felis nisl. Ut iaculis dapibus odio, at suscipit erat vulputate sed. Duis fermentum felis vitae nisl feugiat, a interdum purus efficitur. Aliquam a nulla eros. Vestibulum rutrum pharetra lorem et rhoncus. Suspendisse erat justo, dictum nec nibh vitae, ullamcorper faucibus urna. Nunc eget elit vitae nibh iaculis fringilla. Donec vel quam tortor. Integer mattis blandit ex, quis vulputate mauris maximus vehicula. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent lobortis diam vitae mi posuere fringilla.</p>
                            <p className="content-p read-more-break">Ut lacinia aliquam ultricies. Nunc placerat, lacus sed ornare elementum, nisi eros placerat urna, a faucibus sem lectus id mi. Cras dapibus sem eu hendrerit sollicitudin. Suspendisse eleifend enim et accumsan malesuada. In facilisis ipsum et luctus tempor. Nulla a tellus dapibus, luctus dui vitae, posuere urna. Suspendisse at eros urna. In hac habitasse platea dictumst. Praesent accumsan velit in interdum ultrices. Aliquam vehicula at lacus id gravida. Integer in vestibulum nunc. Mauris vehicula placerat purus a auctor. Integer lacinia arcu nec magna porttitor malesuada. Proin eu porta sem, quis elementum libero. Phasellus ultrices ex tincidunt faucibus pellentesque. Vestibulum volutpat enim nec ex faucibus, eget tincidunt nibh consequat.</p>    
                        </div>
                    </div>
                    <div className="read-more-btn-container">
                        <button className="read-more-button">Više</button>
                    </div>
                    <div className="credits-mobile-container">
                                <p className="author-p">Aleksandar Butulija</p>
                                <p className="date-p">07.10.2004.</p>
                    </div>
                </div> */}
                <VestiComponent data={VestData6}></VestiComponent>
                <VestiComponent data={VestData5}></VestiComponent>
                <VestiComponent data={VestData4}></VestiComponent>
                <VestiComponent data={VestData3}></VestiComponent>
                <VestiComponent data={VestData2}></VestiComponent>
                <VestiComponent data={VestData1}></VestiComponent>
            </div>
        </div>
    )
}

export default VestiPage;